export enum ScreenEnum {
    Digibon = 'Digibon',
    Customer = 'Customer',
}
